import React, { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import CurrentWeather from '../../components/CurrentWeather';
import './Header.scss';

interface HeaderProps {
  siteName?: string;
  children?: React.ReactNode;
  showWeather?: any;
}

export const Header = ({ siteName, showWeather, children }: HeaderProps) => {
  const { appConfig } = useContext(AppContext);
  const { isMobile, isDesktop } = appConfig;
  const showMobile = isMobile && !isDesktop;
  return (
    <>
      <div
        className={`header--container ${showMobile ? 'mobile' : ''} ${showWeather ? 'show-weather' : ''}`}
      >
        <div className="site-name">{siteName}</div>
        <div className="header">
          <div className="header--content">{children}</div>
          {showWeather && (
            <div className="weather-block">
              <CurrentWeather currentCampusData={showWeather}></CurrentWeather>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
